import { HugeiconsIcon } from '@hugeicons/react';
import {
    ChartLineData01Icon,
    CustomerSupportIcon,
    FlowConnectionIcon,
    ChatEdit01Icon,
    BookOpen01Icon,
    McpServerIcon,
    Settings01Icon, Wrench01Icon, VoiceIcon, Route01Icon, AsteriskIcon, BookAIcon, LibraryIcon
} from '@hugeicons/core-free-icons';

const hi = (icon) => <HugeiconsIcon icon={icon} size={20} strokeWidth={1.5} color="currentColor" />;

export const sidebarMenuItems = [
    {
        label: "Dashboard",
        icon: hi(ChartLineData01Icon),
        to: (project) => `/project/${project?.id}`,
        roles: ["ADMIN", "MANAGER", "AGENT"]
    },
    {
        label: "Supervision",
        icon: hi(CustomerSupportIcon),
        to: (project) => `/project/${project?.id}/supervision`,
        roles: ["ADMIN", "MANAGER", "AGENT"]
    },
    {
        label: "Designer",
        icon: hi(FlowConnectionIcon),
        to: (project) => `/project/${project?.id}/flow`,
        roles: ["ADMIN", "MANAGER"]
    },
    {
        label: "Message Annotation",
        icon: hi(ChatEdit01Icon),
        to: (project) => `/project/${project?.id}/message-annotations`,
        roles: ["ADMIN", "MANAGER", "ANNOTATOR"]
    },
    {
        label: "MCP Registry",
        icon: hi(McpServerIcon),
        to: (project) => `/project/${project?.id}/mcp-registry`,
        roles: ["ADMIN", "MANAGER"]
    },
    {
        label: "Knowledge Manager",
        icon: hi(LibraryIcon),
        to: (project) => `/project/${project?.id}/knowledge-manager`,
        disabled: (project) => !project.settings?.organization,
        roles: ["ADMIN", "MANAGER"]
    },
    {
        label: "Settings",
        icon: hi(Settings01Icon),
        roles: ["ADMIN", "MANAGER"],
        submenu: [
            {
                label: "Project Settings",
                icon: hi(Wrench01Icon),
                to: (project) => `/project/${project?.id}/settings`,
                roles: ["ADMIN", "MANAGER"]
            },
            {
                label: "Voice Configuration",
                icon: hi(VoiceIcon),
                to: (project) => `/project/${project?.id}/configuration`,
                roles: ["ADMIN", "MANAGER"]
            },
            {
                label: "Vocabulary",
                icon: hi(BookAIcon),
                to: (project) => `/project/${project?.id}/vocabulary`,
                roles: ["ADMIN", "MANAGER", "AGENT"]
            },
            {
                label: "SIP Configuration",
                icon: hi(AsteriskIcon),
                to: (project) => `/project/${project?.id}/sip`,
                roles: ["ADMIN"]
            },
            {
                label: "SIP Dialplan",
                icon: hi(Route01Icon),
                to: (project) => `/project/${project?.id}/dialplan`,
                roles: ["ADMIN"]
            },
        ]
    }
];
